import { Injectable, computed, signal } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { PermissoesService } from '@shared/services/permissoes.service';

@Injectable({ providedIn: 'root' })
export class UserPermissionsService {
  private readonly _roles = signal<string[]>([]);
  private readonly _loaded = signal(false);

  readonly roles = this._roles.asReadonly();
  readonly loaded = this._loaded.asReadonly();
  readonly rolesSet = computed(() => new Set(this._roles()));

  constructor(private permissoesService: PermissoesService) {}

  load(): Observable<string[]> {
    return this.permissoesService.getCurrentUserPermissions().pipe(
      map((res) => res?.data?.roles ?? []),
      catchError(() => of<string[]>([])),
      map((roles) => {
        this._roles.set(roles);
        this._loaded.set(true);
        return roles;
      }),
    );
  }

  clear(): void {
    this._roles.set([]);
    this._loaded.set(false);
  }

  hasRole(role: string): boolean {
    return this.rolesSet().has(role);
  }

  hasAnyRole(roles: string[]): boolean {
    if (!roles?.length) return true;
    const set = this.rolesSet();
    return roles.some((r) => set.has(r));
  }

  hasAllRoles(roles: string[]): boolean {
    if (!roles?.length) return true;
    const set = this.rolesSet();
    return roles.every((r) => set.has(r));
  }
}
